import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Компонент для інтеграції Google Tag Manager
 * Встановлює GTM на сайт і відстежує зміни сторінок
 * Також передає інформацію про поточну мову у dataLayer
 */
const GoogleTagManager = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const GTM_ID = process.env.REACT_APP_GTM_ID || 'GTM-XXXXXXX'; // Замініть на реальний ID

  // Ініціалізація GTM
  useEffect(() => {
    // Створення dataLayer, якщо його ще немає
    window.dataLayer = window.dataLayer || [];
    
    // Функція для відправки подій у dataLayer
    const gtag = function() {
      window.dataLayer.push(arguments);
    };

    // Ініціалізація GTM
    gtag('js', new Date());
    gtag('config', GTM_ID, {
      send_page_view: false // Не надсилати перегляд сторінки автоматично
    });

    // Додавання скрипту GTM
    const existingScript = document.getElementById('gtm-script');
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'gtm-script';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      document.head.appendChild(script);
      
      // Додавання noscript тегу для GTM
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);
    }
  }, [GTM_ID]);

  // Відстеження зміни сторінки і мови
  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: {
          path: location.pathname,
          language: i18n.language,
          title: document.title
        }
      });
    }
  }, [location.pathname, i18n.language]);

  return null; // Компонент нічого не відображає
};

export default GoogleTagManager; 